import {Set} from 'immutable';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {LibraryId} from '@store/@types/records/Library';
import {CommentId} from 'records/UserComment';
import {Int} from '@store/@types/util';
import LibrarySource from 'sources/library/LibrarySource';
import LibraryHighlightSource from 'sources/library/LibraryHighlightSource';
import LibraryActions from 'actions/library/LibraryActions';
import {TagData} from 'stores/files/FileUploadStore';
import FileUploadActions from 'actions/files/FileUploadActions';

/**
 * Existing implementation doesn't return a promise.
 * Please migrate this to a kotlin api that handles this in a more sane way.
 */
export async function addFileToLibrary(
  callId: FileUploadId,
  libraryId: LibraryId,
  tags: string[],
  changedHighlights: {added: Set<CommentId>; removed: Set<Int>}
): Promise<void> {
  await LibrarySource.addFileToLibrary.remote(null, callId, libraryId, tags);
  await Promise.all([
    ...changedHighlights.added.map(highlightId =>
      LibraryHighlightSource.addLibraryHighlight.remote(null, libraryId, callId, highlightId)
    ),
    ...changedHighlights.removed.map(libHighlightId =>
      LibraryHighlightSource.removeLibraryHighlight.remote(null, libraryId, callId, libHighlightId)
    ),
    LibraryActions.getInfoAboutFiles([callId]),
  ]);
  return;
}

/**
 * Existing implementation doesn't return a promise.
 */
export async function deleteLibraryTag(libraryTag: TagData): Promise<void> {
  await LibrarySource.deleteLibraryTag.remote(null, {
    file_upload_id: libraryTag.file_upload_id,
    delete_library_tags: [
      {
        library_id: libraryTag.library_id,
        tags: [libraryTag.tag_name],
      },
    ],
  });
  return FileUploadActions.getFileInfo(libraryTag.file_upload_id);
}
